import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const LANG_VALUES = ["en", "ar", "gr"];

function normalizeLang(raw) {
  if (!raw || typeof raw !== "string") return "en";
  const base = raw.split(/[-_]/)[0].toLowerCase();
  if (base === "ar") return "ar";
  if (base === "gr" || base === "de") return "gr";
  return LANG_VALUES.includes(base) ? base : "en";
}

const SelectLanguages = () => {
  const { t, i18n } = useTranslation();
  const value = normalizeLang(i18n.resolvedLanguage ?? i18n.language);

  /* One-time hydrate: persist current i18n language, or replay localStorage if it differs */
  // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional mount-only reconcile with persisted `lang`
  useEffect(() => {
    const stored = localStorage.getItem("lang");
    const normalizedStored = normalizeLang(stored ?? "");
    if (stored === null || stored === "") {
      const next = normalizeLang(i18n.resolvedLanguage ?? i18n.language);
      localStorage.setItem("lang", next);
      return;
    }
    if (
      LANG_VALUES.includes(normalizedStored) &&
      normalizedStored !== normalizeLang(i18n.language ?? "")
    ) {
      void i18n.changeLanguage(normalizedStored);
    }
  }, []);

  const handleChange = (next) => {
    void i18n.changeLanguage(next);
    localStorage.setItem("lang", next);
  };

  return (
    <Select onValueChange={handleChange} value={value}>
      <SelectTrigger
        className="rounded-3xl bg-[#e7ebf0] px-md py-[17px]"
        aria-label={t("interview.select_language")}
      >
        <SelectValue placeholder={t("interview.select_language")} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="en">English</SelectItem>
        <SelectItem value="ar">العربية</SelectItem>
        <SelectItem value="gr">German</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default SelectLanguages;
